<template>
  <div class="sections-lateral-spaces">
    <div class="nv-grid page-content">
      <div class="nv-grid-row">
        <div class="nv-grid-col nv-p-0">
          <div class="welcome-section nv-p-2 nv-p-md-4 nv-p-md-4">
            <div class="bg" />
            <div class="nv-mb-2">
              <img
                src="https://assets.nuinalp.com/logo/logo-square.svg"
              >
            </div>
            <div class="nv-mx-auto nv-w-100">
              <h2 class="nv-mb-4">
                {{ $t('which_app_help') }}
              </h2>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Products list -->
      <SupportProductsGrid />
  
      <div class="nv-grid-row">
        <div class="nv-grid-col nv-px-0">
          <div
            class="status-panel nv-p-4 nv-my-4 nv-d-md-flex nv-justify-content-between
              nv-align-items-center"
          >
            <div class="nv-mb-3 nv-mb-xxl-0 nv-w-100 nv-w-lg-60">
              <h2>
                {{ $t('status_panel') }}
              </h2>
              <p>
                {{ $t('status_panel_desc') }}
              </p>
            </div>
            <div class="nv-d-flex nv-flex-column">
              <a
                :href="$config.public.NNP_STATUS_PANEL_URL"
                target="_blank"
                class="nv-d-flex nv-flex-column"
              >
                <nv-button primary>
                  {{ $t('access') }}
                </nv-button>
              </a>
            </div>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Types
import type { InputChangeEventDetail } from '@nuiverse/core/dist/types/interface';

definePageMeta({
  layout: 'support',
  keepalive: true
});

// ---------------------------------------
// Hooks
// ---------------------------------------

const { t } = useI18n();

// --------------------------------------
// Store
// --------------------------------------

// ---------------------------------------
// Meta
// ---------------------------------------

useSeoMeta({
  titleTemplate: t('help_centre'),
  title: t('help_centre'),
  ogTitle: t('help_centre'),
  description: t('support_description'),
  ogDescription: t('support_description'),
});
</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.welcome-section {
  align-items: center;
  border-radius: 8px;
  display: flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 550px;
  overflow: hidden;
  position: relative;

  nv-search-box {
    max-width: 800px;
    width: 100%;
  }

  h2 {
    color: #fff;
    text-align: center;
    text-shadow: 2px 2px 4px #1f506e;
  }

  img {
    height: 104px;
    width: 104px;
  }

  .bg {
    background-image: url('https://assets.nuinalp.com/illustrations/account/sign-wallpaper-optimized.svg');
    background-position-y: 20%;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;

    &::before {
      background-color: rgba(31, 80, 110, 0.35);
      content: '';
      height: 100%;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}

.status-panel {
  --nv-theme-primary: rgb(64, 205, 139);
  --nv-theme-primary-dark: rgb(55, 175, 119);
  --nv-theme-primary-dark-alt: rgb(42, 138, 93);

  position: relative;

  h2 {
    color: rgb(64, 205, 139);
  }

  > div {
    position: relative;
    z-index: 1;
  }

  &::before {
    background-color: rgb(64, 205, 139);
    border-radius: 8px;
    content: '';
    height: 100%;
    left: 0;
    opacity: 0.1;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }
}

</style>
